const formContainer = document.querySelector('[data-form-container]');
if ( formContainer ) {
    const form = formContainer.querySelector('form');
    form.innerHTML = JSON.parse(formContainer.getAttribute('data-form-container')) + form.innerHTML;
}